const axios = require("axios");
const POW = require("./POW");

class Guard {
  constructor(options) {
    this.options = Object.assign(
      {
        recaptchaSiteKey: null,
        recaptchaTimeoutInMillis: 5000,
        powEndpoint: "https://sagateway.careem-internal.com/identity/guard/pow",
        sha1Path: "https://auth.careem.com/guard/sha1.js",
        evalPath: "./eval.js",
        grecaptcha: null,
      },
      options
    );
  }

  execute(action) {
    return new Promise((resolve, reject) => {
      this.doRecaptchaV3(action)
        .then((token) => {
          resolve("recaptcha:" + this.options.recaptchaSiteKey + ":" + token);
        })
        .catch((e) => {
          console.log("Failed with reCaptcha", e);
          return this.doPOW();
        })
        .then((token) => {
          resolve("pow:" + token);
        })
        .catch((err) => {
          console.log("Failed with pow", err);
          reject(err);
        });
    });
  }

  doRecaptchaV3(action) {
    return new Promise((resolve, reject) => {
      let grecaptcha = this.options.grecaptcha || window.grecaptcha;
      if (null == grecaptcha) {
        reject();
      }
      let refTimeout = setTimeout(() => {
        reject("timeout");
      }, this.options.recaptchaTimeoutInMillis);
      grecaptcha.ready(() => {
        try {
          grecaptcha
            .execute(this.options.recaptchaSiteKey, { action })
            .then((token) => {
              clearTimeout(refTimeout);
              resolve(token);
            });
        } catch (ex) {
          clearTimeout(refTimeout);
          reject(ex);
        }
      });
    });
  }

  doPOW() {
    return this.fetchPOWChallenge().then((response) => {
      return this.solvePOWChallenge(response.data);
    });
  }

  fetchPOWChallenge() {
    return axios.get(this.options.powEndpoint);
  }

  solvePOWChallenge(challenge) {
    return new POW({
      evalPath: this.options.evalPath,
      sha1Path: this.options.sha1Path,
    }).solve({
      complexity: challenge.complexity,
      seed: challenge.seed,
      timestamp: challenge.timestamp,
    });
  }
}

module.exports = Guard;
